export interface IRouterState {
  path: RoutePath;
  params?: object;
}
export type RoutePath =
  | '/' // Initial path
  | '/home'
  | '/dynamic'
  | '/batch'
  | '/batch-workspace'
  | '/post-trade'
  | '/quote'
  | '/quote-blotter'
  | '/static'
  | '/essential'
  | '/smart-quote'
  | '/secondary-trade-blotter'
  | '/secondary-market-quotes-workspace'
  | '/secondary-market-batch'
  | '/secondary-market-post-event-workspace'
  | '/secondary-orders-blotter'
  | '/trade-blotter'
  | '/price-improvement-blotter'
  | '/addon-management'
  | '/underlying-universe'
  | '/loading-user-preferences'
  | '/scheduled-quotes-blotter';
export type RouterState = Readonly<IRouterState>;

export const initialRouterState = {
  path: '/',
} as RouterState;
